// extracted by mini-css-extract-plugin
export default {"gearHeader":"VendingGear_gearHeader__5pbo4","gearCheck":"VendingGear_gearCheck__YKWyN","placeHolderShimmer":"VendingGear_placeHolderShimmer__Pl0rB"};